import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { configurationApi, type ConfigurationVersion } from '../../api/configuration';

export function ConfigurationHistoryPage() {
  const [versions, setVersions] = useState<ConfigurationVersion[]>([]);
  const [diff, setDiff] = useState<Record<string, unknown> | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void configurationApi.history().then((r) => setVersions(r.versions)).catch((e) => setError(String(e)));
  }, []);

  async function handlePublish() {
    try {
      await configurationApi.publish();
      const r = await configurationApi.history();
      setVersions(r.versions);
    } catch (e) {
      setError(String(e));
    }
  }

  async function compare(v1: number, v2: number) {
    try {
      const r = await configurationApi.compare(v1, v2);
      setDiff(r.diff);
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/configuration" className="text-sm text-blue-600 hover:underline">← Configuration Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Configuration History & Diff</h1>
      <button type="button" onClick={() => void handlePublish()} className="mt-4 rounded bg-blue-600 px-4 py-2 text-sm text-white">Publish snapshot</button>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-2">
        {versions.map((v) => (
          <li key={v.id} className="flex items-center gap-4 rounded border px-4 py-3 dark:border-slate-700">
            <span>Version {v.version}</span>
            <span className="text-sm text-slate-500">{v.status}</span>
            {versions.length > 1 && v.version > 1 && (
              <button type="button" onClick={() => void compare(v.version - 1, v.version)} className="text-sm text-blue-600">Compare with previous</button>
            )}
          </li>
        ))}
      </ul>
      {diff && (
        <pre className="mt-6 overflow-auto rounded border bg-slate-50 p-4 text-xs dark:border-slate-700 dark:bg-slate-900">
          {JSON.stringify(diff, null, 2)}
        </pre>
      )}
    </div>
  );
}
